import React from 'react';
import { Modal } from '../../components/common/Modal';

export const BulkApplyConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  preview,
  saving,
  errorMessage,
}) => {
  if (!preview) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (!saving) onClose();
      }}
      title={<span className="text-lg font-semibold text-slate-900">一括設定の確認</span>}
      size="lg"
    >
      <div className="space-y-4">
        <p className="text-sm text-slate-700">以下の内容で一括設定します。</p>

        <div className="space-y-4 max-h-[50vh] overflow-y-auto">
          {preview.detailItems.map((detail) => (
            <div
              key={detail.datacode}
              className="border border-slate-200 rounded-md p-3 bg-slate-50"
            >
              <div className="text-sm font-medium text-slate-900 mb-2">
                {detail.productName} / {detail.productSize}
              </div>
              <ul className="space-y-1.5 text-sm text-slate-700">
                {detail.fields.map((field) => (
                  <li key={field.name}>
                    <span className="font-medium text-slate-800">{field.label}:</span>{' '}
                    {field.isAppend && (
                      <span className="text-slate-500 text-xs mr-1">（追記）</span>
                    )}
                    <span className="whitespace-pre-wrap break-words">{field.displayValue}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {preview.showSplitWarning && (
          <p className="text-sm text-amber-700">
            ※ 分納が設定された明細は、分納行の発送日も同じ日付で更新されます。
          </p>
        )}

        {errorMessage && (
          <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
            {errorMessage}
          </div>
        )}

        <div className="flex justify-end gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="px-4 py-2 text-sm text-slate-700 border border-slate-300 rounded-md hover:bg-slate-50 disabled:opacity-50"
          >
            キャンセル
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={saving}
            className="px-4 py-2 bg-slate-700 text-white text-sm rounded-md hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {saving ? '適用中...' : 'OK'}
          </button>
        </div>
      </div>
    </Modal>
  );
};
